import { FormTemplateFieldMap } from 'data/template/template.types';
import i18n from 'i18n';
import { COMMON_GRID_ACTION } from 'shared/commonGrid/grid-enums';
import { AuditActionType } from 'shared/userAudit/audit-constants';
import { OPERATOR } from '../../../shared/form/validators/operatorValidator';

export const STOP_FORM: FormTemplateFieldMap = {
  stopDateTime: {
    label: 'Stop Time',
    icon: 'time',
    type: 'datetime',
    initial: '',
    validation: {
      required: true,
    },
  },
};

export const RESTORE_FORM: FormTemplateFieldMap = {
  newName: {
    label: 'New Name',
    icon: '',
    type: 'text',
    initial: '',
    validation: {
      required: true,
    },
  },
  startDateTime: {
    label: 'Start Time',
    icon: 'time',
    type: 'datetime',
    initial: '',
    validation: {
      required: true,
    },
  },
  stopDateTime: {
    label: 'Stop Time',
    icon: 'time',
    type: 'datetime',
    initial: '',
    validation: {
      required: true,
      validators: [
        {
          type: 'Operator',
          operator: OPERATOR.GREATER_THAN,
          fieldName: 'startDateTime',
          i18nErrorMessageKey: 'warrant.actionPopup.form.fieldError.stopTimeGreaterThanStartTime',
          errorMessage: 'Stop time should be greater than the start time',
        },
      ],
    },
  },
};

export const formatAction = (action: string) => {
  return action
    ? action[0].toUpperCase() + action.slice(1)
    : '';
};

export const adaptToAuditActionType = (action: string): AuditActionType => {
  let auditActionType: AuditActionType = AuditActionType.WARRANT_EDIT;
  switch (action) {
    case COMMON_GRID_ACTION.Delete: auditActionType = AuditActionType.WARRANT_DELETE; break;
    case COMMON_GRID_ACTION.Restore: auditActionType = AuditActionType.WARRANT_RESTORE; break;
    case COMMON_GRID_ACTION.Trash: auditActionType = AuditActionType.WARRANT_TRASH; break;

    case COMMON_GRID_ACTION.Stop:
      auditActionType = AuditActionType.WARRANT_STOP;
      break;
    case COMMON_GRID_ACTION.Start:
      auditActionType = AuditActionType.WARRANT_START;
      break;
    case COMMON_GRID_ACTION.Pause:
      auditActionType = AuditActionType.WARRANT_PAUSE;
      break;
    case COMMON_GRID_ACTION.Reprovision:
      auditActionType = AuditActionType.WARRANT_REPROVISION;
      break;
    case COMMON_GRID_ACTION.Resume:
      auditActionType = AuditActionType.WARRANT_RESUME;
      break;

    default: break;
  }

  return auditActionType;
};

export const isUserAuditEnabledForAction = (action: string): boolean => {
  return (action === COMMON_GRID_ACTION.Delete
          || action === COMMON_GRID_ACTION.Start
          || action === COMMON_GRID_ACTION.Stop
          || action === COMMON_GRID_ACTION.Restore
          || action === COMMON_GRID_ACTION.Trash);
};

export const getUserAuditModeForAction = (action: string): string => {
  return (action === COMMON_GRID_ACTION.Delete || action === COMMON_GRID_ACTION.Trash) ? 'delete' : 'edit';
};

export function getSuccessMessageForAction(name: string, action: string): string {
  switch (action) {
    case COMMON_GRID_ACTION.Start:
      return i18n.t('common.grid.action.success.started', { name });
    case COMMON_GRID_ACTION.Stop:
      return i18n.t('common.grid.action.success.stopped', { name });
    case COMMON_GRID_ACTION.Pause:
      return i18n.t('common.grid.action.success.paused', { name });
    case COMMON_GRID_ACTION.Resume:
      return i18n.t('common.grid.action.success.resumed', { name });
    case COMMON_GRID_ACTION.Reschedule:
      return i18n.t('common.grid.action.success.rescheduled', { name });
    case COMMON_GRID_ACTION.Trash:
      return i18n.t('common.grid.action.success.trashed', { name });
    case COMMON_GRID_ACTION.Delete:
      return i18n.t('common.grid.action.success.deleted', { name });
    case COMMON_GRID_ACTION.Untrash:
    case COMMON_GRID_ACTION.Restore:
      return i18n.t('common.grid.action.success.restored', { name });
    default:
      return i18n.t('common.grid.action.success.default');
  }
}
